/**
 * Utility to handle scroll restoration between page navigations
 * This is a simple implementation that works with React Router and Vite's hot module replacement
 */

// Function to reset scroll position to top
export const scrollToTop = (): void => {
  try {
    // Method 1: Standard window scrollTo
    window.scrollTo(0, 0);
    
    // Method 2: Direct manipulation of scroll properties (for older browsers)
    if (document.documentElement) {
      document.documentElement.scrollTop = 0;
    }
    if (document.body) {
      document.body.scrollTop = 0;
    }
  } catch (error) {
    if (import.meta.env.DEV) {

      if (import.meta.env.DEV) {
        console.error('Error in scrollToTop:', error);
      }

    }
  }
};
